import { useAppSelector } from "Redux/hooks";
import { useRef } from "react";
import { shadeColor } from "../../Logic/ShadeColor";
import { selectStyle } from "Redux/appSlice";
import { leanEntries } from "Constants/defaultStyles";

type Props = {
  id?: string;
  onClick?: () => void;
  label: string;
  className?: string;
  bgColor?: string;
  textColor?: string;
};

/**
   @function Button
   renders button with custom style and function
   @param {string} id - component id
   @param {function} onClick - function called on component click
   @param {string} label - label rendered on Component
   @param {className} - extended className for component 
   @returns {React.Node}
 */
export default function Button({
  id = "",
  onClick,
  label = "",
  className = "",
  bgColor,
  textColor,
}: Props) {
  const { color2 } = useAppSelector(selectStyle);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const backgroundColor = bgColor || color2;
  const finalTextColor = textColor || leanEntries.color2;
  const shadedColor3 = shadeColor(backgroundColor, 20);
  const shadedColor2 = shadeColor(finalTextColor, 20);

  const composedClassName = `
        px-12
        py-2
        rounded-full
        font-bold
        hover:bg-lime-400
        focus:bg-lime-400
        focus:outline-none
        active:bg-lime-600
        transition-colors
        duration-150
        ${className}
    `;

  return (
    <button
      style={{ backgroundColor: backgroundColor, color: finalTextColor }}
      className={composedClassName}
      onClick={onClick}
      id={id}
      ref={buttonRef}
      onMouseOver={() => {
        if (buttonRef.current) {
          buttonRef.current.style.background = shadedColor3;
          buttonRef.current.style.color = shadedColor2;
        }
      }}
      onMouseOut={() => {
        if (buttonRef.current) {
          buttonRef.current.style.background = backgroundColor;
          buttonRef.current.style.color = finalTextColor;
        }
      }}
    >
      {label.toUpperCase()}
    </button>
  );
}
